import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ApplicationIdStates {
  applicationId?: string;
}

const initialState: ApplicationIdStates = {
  applicationId: undefined
};

const ApplicationIdSlice = createSlice({
  name: "Application Id Slice",
  initialState,
  reducers: {
    setApplicationId: (state, action: PayloadAction<string | undefined>) => {
      state.applicationId = action.payload;
    }
  },
  extraReducers: {},
});

export const { setApplicationId } = ApplicationIdSlice.actions;

export default ApplicationIdSlice.reducer;
